import cn from 'classnames'
import { useRouter } from 'next/router'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { APP_PATH } from '../../../pages/app'
import { APP_VIRTUAL_TERMINAL_PATH } from '../../../pages/app/virtual-terminal'
import { APP_TRANSACTIONS_PATH } from '../../../pages/app/transactions'
import { APP_CUSTOMERS_PATH } from '../../../pages/app/customers'
import { proxyGlobalAuth } from '../../proxies/proxyGlobalAuth'
import { APP_RECURRING_PAYMENTS_PATH } from '../../../pages/app/recurring-charges'
import { WastePayPoweredBy } from './Sidebar/WastePayPoweredBy'
import { SupportButton } from './Sidebar/SupportButton'
import { NavigationButton } from './Sidebar/NavigationButton'
import DashboardIcon from './Sidebar/NavigationButtonIcons/DashboardIcon'
import VirtualTerminalIcon from './Sidebar/NavigationButtonIcons/VirtualTerminalIcon'
import TransactionsIcon from './Sidebar/NavigationButtonIcons/TransactionsIcon'
import CustomersListIcon from './Sidebar/NavigationButtonIcons/CustomersListIcon'
import RecurringPaymentsIcon from './Sidebar/NavigationButtonIcons/RecurringPaymentsIcon'

interface SidebarProps {
  expanded: boolean
}

export function Sidebar ({ expanded }: SidebarProps): ReactElement {
  const router = useRouter()
  const { siteTheme: { sideNavBar } } = useSnapshot(proxyGlobalAuth)
  return (
    <aside
      className={
        cn(
          sideNavBar.classes,
          'transition-all ease-in-out flex flex-col justify-between pt-8 min-h-screen h-auto',
          expanded ? 'w-80' : 'w-20'
        )
      }
    >
      <nav>
        <NavigationButton
          path={APP_PATH}
          expanded={expanded}
          text="Dashboard"
          iconComponent={<DashboardIcon active={router.pathname === APP_PATH} />}
          title="Dashboard"
        />

        <NavigationButton
          path={APP_VIRTUAL_TERMINAL_PATH}
          expanded={expanded}
          text="Virtual Terminal"
          iconComponent={<VirtualTerminalIcon active={router.pathname === APP_VIRTUAL_TERMINAL_PATH} />}
          title="Virtual Terminal"
        />

        <NavigationButton
          path={APP_RECURRING_PAYMENTS_PATH}
          expanded={expanded}
          text="Recurring Charges"
          iconComponent={<RecurringPaymentsIcon active={router.pathname === APP_RECURRING_PAYMENTS_PATH} />}
          title="Recurring Charges"
        />

        <NavigationButton
          path={APP_TRANSACTIONS_PATH}
          expanded={expanded}
          text="Transactions"
          iconComponent={<TransactionsIcon active={router.pathname === APP_TRANSACTIONS_PATH} />}
          title="Transactions"
        />

        <NavigationButton
          path={APP_CUSTOMERS_PATH}
          expanded={expanded}
          text="Customers"
          iconComponent={<CustomersListIcon active={router.pathname === APP_CUSTOMERS_PATH} />}
          title="Customers"
        />

        {/*<NavigationButton*/}
        {/*  path={APP_RECURRING_PAYMENTS_PATH}*/}
        {/*  expanded={expanded}*/}
        {/*  text="Recurring Payments"*/}
        {/*  iconComponent={<RecurringPaymentsIcon active={router.pathname === APP_RECURRING_PAYMENTS_PATH} />}*/}
        {/*  title="Recurring Payments"*/}
        {/*/>*/}
      </nav>

      <div className="mb-12 flex flex-col justify-center items-center">
        <SupportButton expanded={expanded} />
        <WastePayPoweredBy expanded={expanded} />
      </div>
    </aside>
  )
}
